const Bar = (props) => {
  return (
    <g>
      <rect
        className="data-bar"
        x={props.xScale(props.item[0][0])}
        height={props.height}
        width={props.getWidth(props.item)}
        fill={props.colourScale(props.item.key)}
      />
      <rect
        className="data-bar-overlay"
        x={props.xScale(props.item[0][0])}
        height={props.height}
        width={props.getWidth(props.item)}
        fill={"white"}
        fillOpacity={0}
        onMouseOver={() => props.showTooltipHandler(props.item.key, props.item[0].data[props.item.key].toLocaleString())}
        onMouseMove={(e) => props.setTooltipPosition(e)}
        onMouseOut={props.hideTooltipHandler}
      />
    </g>
  );
};

export default Bar;
